import React from 'react';
import CrawlImages from '../CrawlImages';
import { CrawlFbResponse } from '../../../../../api/crawlFb';

interface ProcessingStatusProps {
  crawlData: CrawlFbResponse;
}

const ProcessingStatus: React.FC<ProcessingStatusProps> = ({ crawlData }) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center">
        <svg
          className="animate-pulse h-5 w-5 text-blue-500 mr-3"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
        <div>
          <h4 className="text-blue-800 font-medium flex items-center">
            <span className="mr-2">🤖</span>
            Đang đợi AI đọc ảnh...
          </h4>
          <p className="text-blue-700 text-sm mt-1">
            AI đang phân tích và xử lý các ảnh đã crawl được
          </p>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="mt-4">
        <div className="flex items-center text-xs text-blue-600">
          <div className="flex-1 bg-blue-200 rounded-full h-2 mr-3">
            <div
              className="bg-blue-500 h-2 rounded-full animate-pulse"
              style={{ width: '70%' }}
            ></div>
          </div>
          <span>AI đang xử lý...</span>
        </div>
      </div>

      {/* Show crawled images */}
      <CrawlImages crawlData={crawlData} />
    </div>
  );
};

export default ProcessingStatus;
